import { useMemo } from 'react';
import { useModuleConfig } from './queries/admin/useModuleConfig';
import type { IemModuleConfig } from '../types/moduleConfig';

export interface LocationCategoryLabels {
  primaryLabel: string;
  secondaryLabel: string;
  relatedLabel: string;
}

const FALLBACK: LocationCategoryLabels = {
  primaryLabel: 'Primary',
  secondaryLabel: 'Secondary',
  relatedLabel: 'Related',
};

/**
 * Provides configurable location category labels from module.iem configuration.
 * Used in Issue Out workflow location dropdowns for group headers.
 */
export function useLocationCategoryLabels(): LocationCategoryLabels {
  const { config } = useModuleConfig<IemModuleConfig>('iem');
  const categories = config.features.location_categories;

  return useMemo<LocationCategoryLabels>(() => ({
    primaryLabel: categories?.primary_label || FALLBACK.primaryLabel,
    secondaryLabel: categories?.secondary_label || FALLBACK.secondaryLabel,
    relatedLabel: categories?.related_label || FALLBACK.relatedLabel,
  }), [categories]);
}
